/**
 * Packs intelligents pour le métier de MAÇON
 * Templates de travaux complets par type d'ouvrage
 */

import { PackTravaux, TemplateLigne } from './roomTemplates';
import { TypeLigneDevis } from '../types';

// ============================================================================
// PACKS MAÇON - Extension / Agrandissement
// ============================================================================

export const PACKS_MACON_EXTENSION: PackTravaux[] = [
  {
    id: 'macon_extension_20m2',
    nom: 'Extension 20m² Standard',
    description: 'Fondations + élévation murs + dalle béton',
    icone: '🏗️',
    prixEstime: 14200,
    lignes: [
      {
        description: 'Fouille en tranchée pour fondations',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 25,
        prixUnitaire: 32,
        unite: 'ml',
      },
      {
        description: 'Semelle filante béton armé',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 25,
        prixUnitaire: 95,
        tailleReference: '20cm (mur porteur)',
        unite: 'ml',
      },
      {
        description: 'Montage mur parpaing 20cm',
        type: TypeLigneDevis.SURFACE,
        quantite: 40,
        prixUnitaire: 52,
        tailleReference: 'Parpaing 20x20x50',
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Chaînage horizontal béton armé',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 25,
        prixUnitaire: 42,
        unite: 'ml',
      },
      {
        description: 'Dalle béton armé intérieure 12cm',
        type: TypeLigneDevis.SURFACE,
        quantite: 20,
        prixUnitaire: 65,
        tailleReference: '12cm (dalle béton)',
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Isolation thermique extérieure',
        type: TypeLigneDevis.SURFACE,
        quantite: 40,
        prixUnitaire: 42,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
    ],
  },
  {
    id: 'macon_extension_40m2',
    nom: 'Extension 40m² Premium',
    description: 'Extension complète avec finitions',
    icone: '🏛️',
    prixEstime: 27500,
    lignes: [
      {
        description: 'Fouille en tranchée pour fondations',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 35,
        prixUnitaire: 32,
        unite: 'ml',
      },
      {
        description: 'Semelle filante béton armé renforcée',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 35,
        prixUnitaire: 105,
        tailleReference: '25cm (mur porteur)',
        unite: 'ml',
      },
      {
        description: 'Montage mur parpaing 20cm + isolation',
        type: TypeLigneDevis.SURFACE,
        quantite: 60,
        prixUnitaire: 58,
        tailleReference: 'Parpaing 20x20x50',
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Pose linteaux béton préfabriqués',
        type: TypeLigneDevis.PIECE,
        quantite: 4,
        prixUnitaire: 145,
        tailleReference: 'Linteau 20cm',
        unite: 'pièce',
      },
      {
        description: 'Dalle béton armé intérieure 15cm',
        type: TypeLigneDevis.SURFACE,
        quantite: 40,
        prixUnitaire: 72,
        tailleReference: '15cm (dalle béton)',
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Enduit de façade monocouche projeté',
        type: TypeLigneDevis.SURFACE,
        quantite: 60,
        prixUnitaire: 32,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Évacuation gravats (benne 10m³)',
        type: TypeLigneDevis.FORFAIT,
        quantite: 1,
        prixUnitaire: 380,
        unite: 'forfait',
      },
    ],
  },
];

// ============================================================================
// PACKS MAÇON - Terrasse extérieure
// ============================================================================

export const PACKS_MACON_TERRASSE: PackTravaux[] = [
  {
    id: 'macon_terrasse_20m2',
    nom: 'Terrasse 20m² Standard',
    description: 'Hérisson + dalle béton + joints',
    icone: '🏖️',
    prixEstime: 2200,
    lignes: [
      {
        description: 'Décaissement terrain 30cm',
        type: TypeLigneDevis.SURFACE,
        quantite: 20,
        prixUnitaire: 15,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Hérisson pierre 0/31.5 compacté 20cm',
        type: TypeLigneDevis.SURFACE,
        quantite: 20,
        prixUnitaire: 22,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Dalle béton terrasse armée 12cm',
        type: TypeLigneDevis.SURFACE,
        quantite: 20,
        prixUnitaire: 58,
        tailleReference: '12cm (dalle béton)',
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Joint de dilatation périphérique',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 18,
        prixUnitaire: 10,
        unite: 'ml',
      },
      {
        description: 'Évacuation eaux pluviales',
        type: TypeLigneDevis.FORFAIT,
        quantite: 1,
        prixUnitaire: 220,
        unite: 'forfait',
      },
    ],
  },
  {
    id: 'macon_terrasse_40m2_premium',
    nom: 'Terrasse 40m² Désactivée',
    description: 'Terrasse béton désactivé finition premium',
    icone: '✨',
    prixEstime: 4200,
    lignes: [
      {
        description: 'Décaissement terrain et mise à niveau',
        type: TypeLigneDevis.SURFACE,
        quantite: 40,
        prixUnitaire: 18,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Géotextile anti-contaminant',
        type: TypeLigneDevis.SURFACE,
        quantite: 40,
        prixUnitaire: 3,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Hérisson pierre concassée 20cm',
        type: TypeLigneDevis.SURFACE,
        quantite: 40,
        prixUnitaire: 24,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Dalle béton désactivé armée 15cm',
        type: TypeLigneDevis.SURFACE,
        quantite: 40,
        prixUnitaire: 72,
        tailleReference: '15cm (dalle béton)',
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Traitement surface désactivée',
        type: TypeLigneDevis.SURFACE,
        quantite: 40,
        prixUnitaire: 6,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Joints de dilatation',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 25,
        prixUnitaire: 12,
        unite: 'ml',
      },
    ],
  },
];

// ============================================================================
// PACKS MAÇON - Murs et cloisons
// ============================================================================

export const PACKS_MACON_MURS: PackTravaux[] = [
  {
    id: 'macon_cloison_chambre',
    nom: 'Cloison Chambre 15m²',
    description: 'Cloison béton cellulaire 7cm avec porte',
    icone: '🧱',
    prixEstime: 720,
    lignes: [
      {
        description: 'Montage cloison béton cellulaire 7cm',
        type: TypeLigneDevis.SURFACE,
        quantite: 15,
        prixUnitaire: 36,
        tailleReference: '7cm (cloison alvéolaire)',
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Création passage de porte 83cm',
        type: TypeLigneDevis.PIECE,
        quantite: 1,
        prixUnitaire: 150,
        unite: 'pièce',
      },
      {
        description: 'Pose linteau béton 10cm',
        type: TypeLigneDevis.PIECE,
        quantite: 1,
        prixUnitaire: 75,
        tailleReference: 'Linteau 10cm',
        unite: 'pièce',
      },
      {
        description: 'Enduit intérieur plâtre 2 faces',
        type: TypeLigneDevis.SURFACE,
        quantite: 30,
        prixUnitaire: 15,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
    ],
  },
  {
    id: 'macon_mur_porteur_ouverture',
    nom: 'Ouverture dans Mur Porteur',
    description: 'Création ouverture 2m + IPN + reprise',
    icone: '🔨',
    prixEstime: 2050,
    lignes: [
      {
        description: 'Étaiement provisoire structure',
        type: TypeLigneDevis.FORFAIT,
        quantite: 1,
        prixUnitaire: 320,
        unite: 'forfait',
      },
      {
        description: 'Démolition mur porteur 20cm',
        type: TypeLigneDevis.SURFACE,
        quantite: 4,
        prixUnitaire: 120,
        tailleReference: '20cm (mur porteur)',
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Pose IPN métallique 200mm',
        type: TypeLigneDevis.PIECE,
        quantite: 1,
        prixUnitaire: 720,
        unite: 'pièce',
      },
      {
        description: 'Reprise maçonnerie et habillage',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 4,
        prixUnitaire: 95,
        unite: 'ml',
      },
      {
        description: 'Évacuation gravats (benne 3m³)',
        type: TypeLigneDevis.FORFAIT,
        quantite: 1,
        prixUnitaire: 180,
        unite: 'forfait',
      },
    ],
  },
  {
    id: 'macon_muret_cloture',
    nom: 'Muret de Clôture 10ml',
    description: 'Muret parpaing 15cm + enduit',
    icone: '🧱',
    prixEstime: 1550,
    lignes: [
      {
        description: 'Fouille linéaire fondations',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 10,
        prixUnitaire: 28,
        unite: 'ml',
      },
      {
        description: 'Semelle béton armé 30x40cm',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 10,
        prixUnitaire: 62,
        unite: 'ml',
      },
      {
        description: 'Montage muret parpaing 15cm H=1.20m',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 10,
        prixUnitaire: 78,
        tailleReference: 'Parpaing 15x20x50',
        unite: 'ml',
      },
      {
        description: 'Chaînage sommital béton',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 10,
        prixUnitaire: 38,
        unite: 'ml',
      },
      {
        description: 'Enduit monocouche taloché 2 faces',
        type: TypeLigneDevis.SURFACE,
        quantite: 24,
        prixUnitaire: 24,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
    ],
  },
];

// ============================================================================
// PACKS MAÇON - Escaliers
// ============================================================================

export const PACKS_MACON_ESCALIERS: PackTravaux[] = [
  {
    id: 'macon_escalier_beton_droit',
    nom: 'Escalier Béton Droit',
    description: 'Escalier béton coulé 10 marches',
    icone: '🪜',
    prixEstime: 2650,
    lignes: [
      {
        description: 'Coffrage escalier bois sur mesure',
        type: TypeLigneDevis.SURFACE,
        quantite: 12,
        prixUnitaire: 68,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Ferraillage escalier armé',
        type: TypeLigneDevis.PIECE,
        quantite: 10,
        prixUnitaire: 52,
        unite: 'marche',
      },
      {
        description: 'Coulage béton dosé 350kg/m³',
        type: TypeLigneDevis.SURFACE,
        quantite: 2.5,
        prixUnitaire: 350,
        unite: 'm³',
      },
      {
        description: 'Finition marches lissées',
        type: TypeLigneDevis.PIECE,
        quantite: 10,
        prixUnitaire: 28,
        unite: 'marche',
      },
      {
        description: 'Décoffrage et nettoyage',
        type: TypeLigneDevis.FORFAIT,
        quantite: 1,
        prixUnitaire: 220,
        unite: 'forfait',
      },
    ],
  },
  {
    id: 'macon_escalier_ext_4_marches',
    nom: 'Escalier Extérieur 4 Marches',
    description: 'Escalier extérieur béton avec nez de marche',
    icone: '🏔️',
    prixEstime: 1150,
    lignes: [
      {
        description: 'Décaissement et fondations',
        type: TypeLigneDevis.SURFACE,
        quantite: 2,
        prixUnitaire: 75,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Coffrage escalier extérieur',
        type: TypeLigneDevis.SURFACE,
        quantite: 4,
        prixUnitaire: 60,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Ferraillage et coulage béton',
        type: TypeLigneDevis.PIECE,
        quantite: 4,
        prixUnitaire: 98,
        unite: 'marche',
      },
      {
        description: 'Nez de marche antidérapant',
        type: TypeLigneDevis.PIECE,
        quantite: 4,
        prixUnitaire: 22,
        unite: 'pièce',
      },
    ],
  },
];

// ============================================================================
// PACKS MAÇON - Rénovation et démolition
// ============================================================================

export const PACKS_MACON_RENOVATION: PackTravaux[] = [
  {
    id: 'macon_demo_cloison',
    nom: 'Démolition Cloison 10m²',
    description: 'Dépose cloison + évacuation gravats',
    icone: '💥',
    prixEstime: 370,
    lignes: [
      {
        description: 'Démolition cloison placo/brique',
        type: TypeLigneDevis.SURFACE,
        quantite: 10,
        prixUnitaire: 18,
        tailleReference: '7cm (cloison alvéolaire)',
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Évacuation gravats',
        type: TypeLigneDevis.FORFAIT,
        quantite: 1,
        prixUnitaire: 150,
        unite: 'forfait',
      },
      {
        description: 'Rebouchage sol et murs',
        type: TypeLigneDevis.FORFAIT,
        quantite: 1,
        prixUnitaire: 100,
        unite: 'forfait',
      },
    ],
  },
  {
    id: 'macon_reprise_fissure',
    nom: 'Reprise Fissures Importantes',
    description: 'Traitement et consolidation fissures mur',
    icone: '🔧',
    prixEstime: 1050,
    lignes: [
      {
        description: 'Ouverture et nettoyage fissures',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 15,
        prixUnitaire: 15,
        unite: 'ml',
      },
      {
        description: 'Injection résine époxy',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 15,
        prixUnitaire: 38,
        unite: 'ml',
      },
      {
        description: 'Pose treillis de renfort',
        type: TypeLigneDevis.SURFACE,
        quantite: 8,
        prixUnitaire: 28,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Enduit de reprise et finition',
        type: TypeLigneDevis.SURFACE,
        quantite: 8,
        prixUnitaire: 22,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
    ],
  },
];

// ============================================================================
// PACKS MAÇON - Étanchéité et drainage
// ============================================================================

export const PACKS_MACON_ETANCHEITE: PackTravaux[] = [
  {
    id: 'macon_cuvelage_cave',
    nom: 'Cuvelage Cave 30m²',
    description: 'Traitement humidité + cuvelage complet',
    icone: '💧',
    prixEstime: 3650,
    lignes: [
      {
        description: 'Piquetage ancien enduit dégradé',
        type: TypeLigneDevis.SURFACE,
        quantite: 30,
        prixUnitaire: 18,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Drainage périphérique intérieur',
        type: TypeLigneDevis.UNITAIRE,
        quantite: 20,
        prixUnitaire: 45,
        unite: 'ml',
      },
      {
        description: 'Application membrane étanche',
        type: TypeLigneDevis.SURFACE,
        quantite: 30,
        prixUnitaire: 38,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Enduit de cuvelage ciment',
        type: TypeLigneDevis.SURFACE,
        quantite: 30,
        prixUnitaire: 32,
        unite: 'm²',
        modeSaisieSurface: 'direct',
      },
      {
        description: 'Pompe de relevage eaux infiltration',
        type: TypeLigneDevis.PIECE,
        quantite: 1,
        prixUnitaire: 720,
        unite: 'pièce',
      },
    ],
  },
];

// ============================================================================
// Export de tous les packs Maçon regroupés
// ============================================================================

export const TOUS_PACKS_MACON: PackTravaux[] = [
  ...PACKS_MACON_EXTENSION,
  ...PACKS_MACON_TERRASSE,
  ...PACKS_MACON_MURS,
  ...PACKS_MACON_ESCALIERS,
  ...PACKS_MACON_RENOVATION,
  ...PACKS_MACON_ETANCHEITE,
];
